import { Navigate, useLocation } from "react-router-dom";

const PATHWAYS_ROUTE = "/my-apps/pathways";

/**
 * Frontdoor does not render Search Insights directly. Chat links can still land
 * on this host as /search_insights/..., so route them through the installed
 * Pathways app shell using the same deep-link url param as other iframe apps.
 */
export const getSearchInsightsRedirectPath = ({
  hash = "",
  pathname,
  search = "",
}: {
  hash?: string;
  pathname: string;
  search?: string;
}) => {
  const nestedPath = `${pathname}${search}${hash}`;

  return `${PATHWAYS_ROUTE}?url=${encodeURIComponent(nestedPath)}`;
};

const SearchInsightsRedirect = () => {
  const location = useLocation();

  return (
    <Navigate
      replace
      to={getSearchInsightsRedirectPath({
        hash: location.hash,
        pathname: location.pathname,
        search: location.search,
      })}
    />
  );
};

export default SearchInsightsRedirect;
